import { useEffect, useState } from 'react';

import { getPublicBranding } from 'api/settings';

let publicBrandingRequest;

const fetchPublicBranding = async () => {
    // Share concurrent requests, but refresh on a later visit because trial status can change.
    publicBrandingRequest ||= getPublicBranding().finally(() => {
        publicBrandingRequest = null;
    });

    const response = await publicBrandingRequest;
    return response?.data || {};
};

/**
 * Loads public organisation details shared by unauthenticated portal content
 *
 * @returns {Object} Public branding, trial status and an isLoading flag
 */
const usePublicBranding = () => {
    const [branding, setBranding] = useState({ isLoading: true });

    useEffect(() => {
        let active = true;

        fetchPublicBranding()
            .then((data) => {
                if (active) setBranding({ ...data, isLoading: false });
            })
            .catch((error) => {
                const isDeploymentNotFound = error?.code === 'deployment_not_found' || /deployment.*not.*found/i.test(error?.message || '');
                if (active) setBranding({ isLoading: false, isDeploymentNotFound });
            });

        return () => {
            active = false;
        };
    }, []);

    return branding;
};

export default usePublicBranding;
